import { Component } from '@angular/core';
import { DatePipe, JsonPipe, NgIf } from "@angular/common";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ClrDatagridModule, ClrIconModule, ClrModalModule, ClrTabsModule, ClrTooltipModule } from "@clr/angular";
import {ClarityIcons, noteIcon, infoCircleIcon, pencilIcon, windowCloseIcon, minusCircleIcon} from "@cds/core/icon";
import { getTenantLetterAssets } from '../../../_shared/utils/letter-assets';
import { getTenantConfig } from '../../../_shared/utils/tenant-context';
import {
  NotificationDetailsDocumentsComponent
} from "./notification-details-documents/notification-details-documents.component";
import { NotificationEditPositionsComponent } from "./notification-edit-positions/notification-edit-positions.component";

import { environment as env } from "../../../../environments/environment";
import {
  AlertService, FileStoreService,
  IAlertType,
  NotificationStoreService,
  PersonsStoreService,
  StaffStoreService
} from "../../../_shared/services";
import {NotificationList, Personen, SingleNotification } from "../../../_shared/interfaces";
import moment from "moment";
import PackageJson from "../../../../../package.json";

@Component({
  selector: 'app-notification-details',
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
    DatePipe,
    ClrTabsModule,
    ClrIconModule,
    ClrDatagridModule,
    ClrTooltipModule,
    ClrModalModule,
    JsonPipe,
    NotificationDetailsDocumentsComponent,
    NotificationEditPositionsComponent
  ],
  templateUrl: './notification-details.component.html',
  styleUrl: './notification-details.component.sass'
})
export class NotificationDetailsComponent {
  projectId: string = '';
  orderId: number = 0;
  jobId: number = 0;
  notificationId: number = 0;
  notificationType: number = 0;
  notification: SingleNotification = new SingleNotification();
  positions: NotificationList[]= [];
  person: Personen[] = [];
  editPos: number = 0;
  loading1: boolean = true;
  loading2: boolean = true;
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  staffPhone: string = '';
  selected: NotificationList[] = [];
  positionId: number = 0;
  partId: number = 0;

  public ppsVersion: string = PackageJson.version;

  devMode: boolean;
  private readonly tenantConfig = getTenantConfig();
  // Für Ausdruck
  basic: boolean = false;
  documentDefinition = getTenantLetterAssets().a4Letter;

  constructor(
    private notss: NotificationStoreService,
    private staffss: StaffStoreService,
    private persss: PersonsStoreService,
    private filess: FileStoreService,
    private alertDispatcher: AlertService,
    private router: Router,
    private route: ActivatedRoute
) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(noteIcon, minusCircleIcon, infoCircleIcon, pencilIcon, windowCloseIcon)
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.jobId = parseInt(params.get('jobid') ?? '0', 10);
    this.notificationId = parseInt(params.get('notid') ?? '0', 10);
    this.loadNotification(this.projectId, this.jobId, this.notificationId);
    this.loadNotificationsPosition(this.projectId, this.notificationId);
  }

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }

  loadNotification(projectID: string, jobID: number, notificationID: number){
    this.notss.getSingleNotification(projectID, notificationID).subscribe(data1 => {
      if (!data1) {
        return;
      }
      this.notification = data1.object[0];
      // console.log("301 " + this.notification.city);
      // console.table(this.notification);
      this.loading1 = false;

      // OrderID auslesen
      this.orderId = parseInt(this.notification.order_id);

      // Typ auslesen
      this.notificationType = this.notification.notification_type;

      // Mitarbeiter personalisieren
      this.staffStatus(this.notification.employee_phm);

      // Person ermitteln
      if (this.notification.employee_leader > 0) {
        this.loadPersonData(this.notification.employee_leader);
      }
    });
  }

  loadNotificationsPosition(projectID: string, notificationID: number) {
    this.notss.getNotificationsPositions(projectID, notificationID, 0, 0).subscribe({
      next: data2 => {
        if (!data2 || !data2.object) {
          this.alertDispatcher.show({
            message: 'Keine Notificationpositionen gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
      this.positions = data2.object;
      },
        complete: () => {
        this.loading2 = false;
      },
        error: () => {
        return
      }
    });
  }

  async updateNotification(done: boolean) {
    this.editPos = 1;

    this.loadNotification(this.projectId, this.jobId, this.notificationId);
    this.loadNotificationsPosition(this.projectId, this.notificationId);
    this.createNotification(this.positions)
  }

  deleteNotification(projectID: string, jobID: number, notificationID: number) {
    if (confirm('Wollen Sie diese Mitteilung wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.notss.deleteNotification(projectID, notificationID)
        .subscribe({
          next: () => {
          },
          complete: () => {
            this.router.navigate(['/job/details/', projectID, jobID])
          },
          error: () => {
            return
          }
        });
    }
  }
  createNotification(positions: any []) {
    let posTable = [[{ text: 'Pos.'}, { text: 'Bezeichnung'}, { text: 'Zeichnung' }, { text: 'Anzahl'}, { text: 'Bemerkung'}]];

    positions.forEach(position => {
      if (position.remarks == 'null') position.remarks = '---';

      switch(position.part) {
        case 0: {
          if (position.number_of_pieces === 0) {
            posTable.push(
              [ position.position, position.name, position.technical_drawing, '', position.remarks ]
            );
          } else {
            posTable.push(
              [ position.position, position.name, position.technical_drawing, position.number_of_pieces, position.remarks ]
            );
          }
          break;
        }
        default: {
          if (position.number_of_pieces === 0) {
            posTable.push(
              [ position.position + '.' + position.part, position.name, position.technical_drawing, '', position.remarks ]
            );
          } else {
            posTable.push(
              [ position.position + '.' + position.part, position.name, position.technical_drawing, position.number_of_pieces, position.remarks ]
            );
          }
          break;
        }
      }
    });

    this.documentDefinition.info.title = 'PPS Mitteilung';
    this.documentDefinition.info.subject = 'MITTEILUNG ' + this.projectId + '.0007.' + this.notificationId;
    this.documentDefinition.info.revison = this.ppsVersion;

    (this.documentDefinition.content[0] as any).columns[0].text = this.notification.company_name + '\n' + this.notification.street + '\n' + this.notification.postcode + ' ' + this.notification.city;
    if(this.notification.country && (this.notification.country != 'Deutschland')) {
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + this.notification.country
    }
    const person = this.person?.[0];
    const personSalutation = person?.salutation ?? '';
    const personLastname = person?.lastname ?? '';
    const personPhone = person?.phone ?? '';
    const personEmail = person?.email ?? '';

    if(this.notification.employee_leader && person) {
      (this.documentDefinition.content[0] as any).columns[0].text += '\n\n' + personSalutation + ' ' + personLastname;
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + personPhone;
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + personEmail;
    }

    (this.documentDefinition.content[0] as any).columns[2].text = this.tenantConfig.letterCity + ', ' + moment(this.notification.notification_date).format("DD.MM.yyyy") + '\n\nIhr Ansprechpartner:\n' + this.staffFirstName + ' ' + this.staffLastName + '\n' + this.staffEMail;
    this.documentDefinition.content[1].text = 'MITTEILUNG ' + this.projectId + '.0007.' + this.notificationId;
    this.documentDefinition.content[2].text = 'gemäß unserem Job ' + this.projectId + '.0006.' + this.jobId + ' laut Auftrag: ' + this.notification.order_id ;

    if(this.notification.subject) { this.documentDefinition.content[3].text = 'BETREFF: ' + this.notification.subject + '\n\n'; }
    this.documentDefinition.content[3].text = 'Sehr geehrte(r) ' + personSalutation + ' ' + personLastname + ',\n\nBezug nehmend auf die oben genannte Bestellung mit unten aufgeführten Positionen teilen wir Ihnen folgendes mit:\n\n';

    (this.documentDefinition.content[4] as any).table.headerRows = 1;
    (this.documentDefinition.content[4] as any).table.widths = [ 'auto', '*', 'auto', 'auto', 'auto' ];
    (this.documentDefinition.content[4] as any).table.body = posTable;
    (this.documentDefinition.content[5] as any) = { text: '', margin: [0, 0, 0, 0] };
    (this.documentDefinition.content[6] as any) = { text: '', margin: [0, 0, 0, 0] };
    this.documentDefinition.content.splice(7);

    this.generatePdf();
  }

  openPdfPreview() {
    this.basic = true;
    // Wait until the modal body exists in the DOM before injecting the iframe.
    setTimeout(() => this.createNotification(this.positions), 0);
  }

  generatePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);

    documentGenerator.getDataUrl((dataUrl: string) => {
      const targetElement = document.querySelector('#documentContainer');
      if (!targetElement) {
        this.alertDispatcher.alertConfig.message = 'PDF-Container nicht gefunden!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
        return; // Exit the function if the element doesn't exist
      }
      targetElement.innerHTML = '';

      const pdfIframe = document.createElement('iframe');
      pdfIframe.src = dataUrl;
      pdfIframe.width = '100%';
      pdfIframe.height = '100%';
      targetElement.appendChild(pdfIframe);
    })
  }

  staffStatus(staffID: number){
    // console.log('StaffID ist ' + staffID);
    this.staffss.getStaffById(staffID)
      .subscribe(staff => {
        if (!staff) {
          return;
        }
        this.staffFirstName = staff.object[0].firstname;
        this.staffLastName = staff.object[0].lastname;
        this.staffEMail = staff.object[0].email;
        this.staffPhone = staff.object[0].phone;
      })
  }

  loadPersonData(person: number) {
    return this.persss.getSinglePersons(person)
      .subscribe( res => this.person = res.object);
  }

  // TBC
  updatePositionMode(i: number, positionID: number, partID: number) {
    this.editPos = 2;
    this.positionId = positionID;
    this.partId = partID;
  }

  deletePosition(projectID: string, notificationID: number, positionId: number, partId: number) {
    this.notss.deleteNotificationsPosition(projectID, notificationID, positionId, partId)
      .subscribe({
        next: () => {
        this.loadNotificationsPosition(projectID, notificationID);
        },
        complete: () => {
          this.alertDispatcher.show({
            message: ' Position ' + positionId + '.' + partId + ' wurde gelöscht. ',
            clrAlertType: IAlertType.INFO
          }, 2000);
        },
        error: () => {
          return
        }
      });
  }

  onDelete() {
    let choosenPositions = this.selected;
    if (confirm('Wollen Sie die ausgewählten Positionen tatsächlich löschen?')) {
      choosenPositions.forEach(array => {
        this.deletePosition(this.projectId, this.notificationId, array.position, array.part ?? 0)
      });

      this.loadNotification(this.projectId, this.jobId, this.notificationId);
      this.loadNotificationsPosition(this.projectId, this.notificationId);

      this.alertDispatcher.alertConfig.message = 'Die Positionen wurden gelöscht.';
      this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
    }
  }

  archivePdf() {
    if (confirm('Wollen Sie die Datei ' + 'Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf archivieren?')) {
      this.safePdf();
    }
  }

  async downloadPdf(){
    if (confirm('Wollen Sie die Datei ' + 'Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf wirklich herunterladen?')) {
      const documentGenerator = pdfMake.createPdf(this.documentDefinition).download('Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf');
    }

    await this.safePdf();

    this.alertDispatcher.alertConfig.message = 'Datei ' + 'Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf wurde herunterladen.';
    this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
  }

  async printPdf() {
    if (confirm('Wollen Sie die Datei ' + 'Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf ausdrucken?')) {
      pdfMake.createPdf(this.documentDefinition).print();
    }

    await this.safePdf()

    this.alertDispatcher.show({
      message: ' Datei ' + 'Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf wurde an den Drucker übergeben. ',
      clrAlertType: IAlertType.INFO
    }, 2000);
  }

  safePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);
    documentGenerator.getBlob((blob: Blob) => {
      // Convert Blob to File
      const file = new File(
        [blob], // Blob content
        'Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf',
        { type: blob.type, lastModified: Date.now() } // File metadata
      );

      // Now, send the file instead of the Blob
      // Type 60 = order notification: job_number=job_id, sub_number=order_pps
      // Type 61 = job notification:   job_number=job_id, sub_number=0
      const fileJobNumber = this.jobId || Number(this.notification.job_id);
      const fileSubNumber = this.notificationType === 60 ? Number(this.notification.order_pps) : 0;
      this.filess.sendFile(file, this.notificationType, fileSubNumber, this.notification.project_id, fileJobNumber, '', 'Mitteilung ' + this.notification.project_id + '.0007.' + this.notification.notification_id)
        .subscribe({
          next: () =>
          {
            if (this.devMode) console.log("done")
          },
          complete: () => {
            this.alertDispatcher.show({
              message: ' Datei ' + 'Notification_' + this.notification.project_id + '.0007.' + this.notification.notification_id + '.pdf wurde gespeichert.',
              clrAlertType: IAlertType.SUCCESS
            }, 5000);
          },
          error: (error) => console.error("Error:", error)
        });
    });
  }
}
